module.exports = {"about":{"title":"The legend of St. George","blockquote":"","body":"<p>St. George was born to Gerontius and Polychronia, a noble christian family in Lod Syria some time between 275 and 285 AD. His father was a roman army official. The eastern churches have named his parents as the Anastius and the Obaste.</p>"},"notifications":["Test notification 1","Test notification 2"],"test":"test string"}


//////////////////
// WEBPACK FOOTER
// ./data.json
// module id = wAIJ
// module chunks = 0